import { BonusStage } from 'api/common';
import type { i18n, TFunction } from 'i18next';

export const getBonusStatusNameTranslation = (
  t: TFunction,
  i18n: i18n,
  stage: BonusStage,
  plainText?: boolean
) => {
  const stageName = stage === BonusStage.HandleBets ? 'active' : stage;

  const translation = i18n.exists(`bonuses:bonusStatuses.${stageName}`)
    ? t(`bonuses:bonusStatuses.${stageName}`)
    : stageName;

  const translationSplitted = translation.split('\n');

  if (plainText) return translationSplitted.join(' ');

  return translationSplitted.map((item, index) => (
    <span key={index}>
      {item}
      {index < translationSplitted.length - 1 && <br />}
    </span>
  ));
};

export const removeNonAlphanumeric = (str: string) =>
  str.replace(/[^a-zA-Z0-9]/g, '');

export const checkHasTermsAndConditions = (
  termsAndConditions: string | null | undefined
) => {
  if (!termsAndConditions) return false;

  const tagRegex = /<[^>]*>/gm;
  const contentRegex = /[^<>\s]+/gm;

  return contentRegex.test(termsAndConditions?.replace(tagRegex, ''));
};

export const BONUS_REF_PARAM = 'bonus-ref';
